import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    paymentDetails: {
        id: 'new_cards.payment_details',
        defaultMessage: 'Payment details',
    },
    issueCost: {
        id: 'new_cards.payment_details.issue_cost',
        defaultMessage: 'Issue cost',
    },
    total: {
        id: 'new_cards.payment_details.total',
        defaultMessage: 'Total',
    },
})
